import { useQuery } from 'react-query';

import { APIBaseChronos } from '@/api/hosts';
import { QueryEntity } from '@/api/types';
import useGetFetchConfig, { FetchMethod } from '@/api/useGetFetchConfig';

export const useGetPersonNames = (matterId: string, subsetId: string, personIds: string[]) => {
  const { getFetchConfig } = useGetFetchConfig();
  const sortedIds = [...personIds].sort();

  const fetchConfig = getFetchConfig({
    method: FetchMethod.POST,
    data: { ids: sortedIds },
  });

  return useQuery<Array<{ id: string; name: string }>>(
    [QueryEntity.PersonNames, { subsetId, personIds: sortedIds }],
    async () => {
      const response = await fetch(
        `${APIBaseChronos}/api/matter/${matterId}/subset/${subsetId}/persons/resolve-names`,
        fetchConfig,
      );
      if (!response.ok) throw new Error('Failed to resolve person names');
      return response.json();
    },
    {
      enabled: personIds.length > 0,
      refetchOnWindowFocus: false,
    },
  );
};
